import entity from '../../../models/marketing/contacts'

export default [
  {
    path: '/contacts',
    meta: {
      entity,
      requiresPermissionTo: 'contacts',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'contacts' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/contacts/new',
    meta: {
      entity,
      requiresPermissionTo: 'contacts',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'contacts' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/contacts/:id',
    meta: {
      entity,
      requiresPermissionTo: 'contacts',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'contacts' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
